var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('vs-switch',{staticClass:" p-2",attrs:{"vs-icon-on":"wb_sunny","vs-icon-off":"brightness_3"},on:{"change":_vm.themeMode},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }